"use client";

import type { HallowABFlag } from "@packages/ab";
import { useFlag } from "@packages/ab";
import { useMemo } from "react";

import type { CTAProps } from "./CTA";
import { CTA } from "./CTA";

type CtaWithABTestProps = {
  baseProps: CTAProps;
  treatmentProps: Partial<CTAProps>;
  flag: HallowABFlag;
  treatmentValue?: string;
};

export const CtaWithABTest = ({
  baseProps,
  treatmentProps,
  flag,
  treatmentValue = "treatment",
}: CtaWithABTestProps) => {
  const { isTargeted, value } = useFlag({
    isTargetedValue: treatmentValue,
    key: flag,
  });
  const props = useMemo(
    () => ({ ...baseProps, ...(isTargeted ? treatmentProps : {}) }),
    [baseProps, treatmentProps, isTargeted, value],
  );
  return <CTA {...props} />;
};
